import { Alert } from 'antd';
import { Mail } from 'lucide-react';
import { ConfirmItsYouPanel } from '../../../components/ConfirmItsYouPanel';
import { useEmailOtp } from '../hooks/use-email-otp';
import { EmailOtpCodeForm } from './EmailOtpCodeForm';
import { RecoveryCodesReveal } from './RecoveryCodesReveal';
import { TwoFactorRow } from './TwoFactorRow';
import { TwoFactorSwitch } from './TwoFactorSwitch';

export function EmailOtpRow({ email, isOn, canTurnOn }: { email: string; isOn: boolean; canTurnOn: boolean }) {
  const { setup, error, submitting, confirmation, start, resend, verify, finish, disable, cancel } = useEmailOtp();
  const isIdle = setup.phase === 'idle' && confirmation.state.phase === 'idle';

  return (
    <TwoFactorRow
      icon={Mail}
      title="Email code"
      isOn={isOn}
      description={isOn ? `A code sent to ${email} finishes a password sign-in.` : `Get a 6-digit code at ${email} after your password.`}
      action={isIdle && <TwoFactorSwitch method="email codes" isOn={isOn} canTurnOn={canTurnOn} submitting={submitting} onTurnOn={start} onTurnOff={disable} />}
    >
      {isIdle && error && <Alert className="mt-4" type="error" title={error} showIcon />}
      <ConfirmItsYouPanel confirmation={confirmation} />
      {setup.phase === 'code' && (
        <div className="mt-4">
          <EmailOtpCodeForm
            email={email}
            displayedCode={setup.displayedCode}
            error={error}
            submitting={submitting}
            onVerify={verify}
            onResend={resend}
            onCancel={cancel}
          />
        </div>
      )}
      {setup.phase === 'recovery-codes' && (
        <div className="mt-4">
          <RecoveryCodesReveal codes={setup.codes} onDone={finish} />
        </div>
      )}
    </TwoFactorRow>
  );
}
